'use client';

import { useState, useEffect } from 'react';

export enum DeviceType {
  Mobile = 'mobile',
  Desktop = 'desktop',
}

function useDeviceType() {
  const [deviceType, setDeviceType] = useState<DeviceType>(DeviceType.Desktop);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (/android|iphone|ipad|ipod/.test(userAgent)) {
      setDeviceType(DeviceType.Mobile);
    } else {
      setDeviceType(DeviceType.Desktop);
    }
  }, []);

  return deviceType;
}

export default useDeviceType;
